import React, { useEffect, useState } from "react";

import { useGetDatasetGroups } from "api/api-hooks/dataset-groups-hooks";
import { DatasetGroup } from "api/model/dataset/datasetGroups";
import { Toolbar } from "primereact/toolbar";
import { Tree, TreeSelectionKeys } from "primereact/tree";
import TreeNode from "primereact/treenode";
import "./DatasetGroup.scss";
import AddSubgroupButton from "./components/AddSubgroupButton";
import DeleteGroupButton from "./components/DeleteGroupButton";
import RenameGroupButton from "./components/RenameGroupButton";
import { mapDatasetGroupsToTreeNodes } from "./dataset-group-utils";

const DatasetGroupsSettings: React.FC = () => {
  const [nodes, setNodes] = useState<TreeNode[]>([]);
  const [group, setGroup] = useState<DatasetGroup | null>(null);
  const [selectedKey, setSelectedKey] = useState<TreeSelectionKeys>(null);
  const { data } = useGetDatasetGroups();

  useEffect(() => {
    if (data) {
      const treeNodes = mapDatasetGroupsToTreeNodes(data);
      setNodes(treeNodes);
    }
  }, [data])

  const toolbarContent = (
    <>
      <AddSubgroupButton group={group}/>
      <RenameGroupButton group={group} />
      <DeleteGroupButton group={group} />
    </>
  )

  return (
    <div className="p-3">
      <Toolbar className="mb-4 bg-white border-none p-0" left={toolbarContent} />
      <Tree
        value={nodes}
        selectionMode="single"
        selectionKeys={selectedKey}
        metaKeySelection={false}
        onSelectionChange={e => setSelectedKey(e.value)}
        onSelect={e => setGroup(e.node.data)}
        onUnselect={() => setGroup(null)}
        className="dataset-group-tree"
      />
    </div>
  );
}

export default DatasetGroupsSettings;